// JavaScript 相关

export function pad(num, n) {
  n = isUndefined(n) ? 2 : +n
  num = String(num)
  while (num.length < n) {
    num = '0' + num
  }
  return num
}

export function isString(str) {
  return 'string' === typeof str
}

export function trim(str) {
  if (!isString(str)) {
    return str
  }
  return str.replace(/^\s+|\s+$/g, '')
}

// IE8
export var isArray = Array.isArray || function isArray(arr) {
  return toString.call(arr) === '[obejct Array]'
}

export function isUndefined(obj) {
  return void 0 === obj
}

export function isObject(obj) {
  return typeof obj === 'object'
}

export function isFunction(obj) {
  return 'function' === typeof obj
}

function plainObject() {
  return {}
}

function hasOwn() {
  return plainObject().hasOwnProperty
}

// IE8+
export function isPlainObject(obj) {
  if (!obj || Object.prototype.toString.call( obj ) !== '[object Object]') {
    return false
  }

  var proto = Object.getPrototypeOf(obj)

  if (!proto) {
    return true
  }

  var Ctor = hasOwn.call(proto, 'constructor') && proto.constructor
  return typeof Ctor === 'function' && hasOwn.toString.call(Ctor) === hasOwn.toString.call(Object)
}

// IE8+
export function deepExtend() {
  var options, name, src, copy, copyIsArray, clone
  var target = arguments[0] || {}
  var length = arguments.length

  if (!isObject(target) && !isFunction(target)) {
    target = {}
  }

  for (var i = 1; i < length; i++) {
    if ((options = arguments[i]) != null ) {

      if (isString(options)) {
        continue
      }

      for (name in options) {
        src = target[name]
        copy = options[name]

        // 防止循环引用
        if (target === copy) {
          continue
        }

        // Recurse if we're merging plain objects or arrays
        if (copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {

          if (copyIsArray) {
            copyIsArray = false
            clone = src && isArray(src) ? src : []
          } else {
            clone = src && isPlainObject(src) ? src : {}
          }

          // Never move original objects, clone them
          target[name] = deepExtend(clone, copy)
          target[name] = deepExtend(clone, copy)

        // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy
        }
      }
    }
  }

  // Return the modified object
  return target
}
